const cache = (() => {
    return {
        OFFERS_CACHE: 'offersHotelCache',
        MENUBAR_CACHE: 'menubarCache',
        MENUBAR_CACHE_B2C: 'menubarCacheB2c',
        FOOTER_CACHE: 'footerCache',
        LEFTNAV_CACHE: 'leftNavCache',
    };
})();
export default cache;
